import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';

import { useMegaphoneOnboardContext } from '@account_module/context/MegaphoneOnboardContext';
import { MEGAPHONE_ONBOARDING_STEP_KEYS } from '@account_module/constants/onBoardingKeys';
import { IntegrationOnboardingChecklistType } from '@account_module/types/Onboarding';

import { CheckMarkIcon } from '@icons/CheckMarkIcon';
import { CopyIcon2 } from '@icons/CopyIcon2';

const ChecklistWrapper = tw.div`w-[300px] h-full flex flex-col justify-between rounded-lg bg-white border border-solid border-card-border px-[16px] py-[24px]`;
const ChecklistTitle = tw.div`text-primary text-left text-[18px] font-bold flex items-center justify-start gap-2 mb-[40px]`;
const ListItem = tw.li`flex items-center justify-start gap-2 p-[8px] text-sm rounded-[7px] font-semibold mb-2`;
const ItemCheckbox = tw.div`w-[32px] h-[32px] rounded-full border border-solid border-accent bg-white flex items-center justify-center`;
const CheckmarkWrapper = tw.div`w-[26px] h-[26px] bg-accent rounded-full flex items-center justify-center`;
const SupportCTA = tw.button`text-sm font-semibold text-accent underline inline w-auto text-left`;

const megaphoneIntegrationOnboardingChecklist: IntegrationOnboardingChecklistType[] = [
  {
    key: MEGAPHONE_ONBOARDING_STEP_KEYS.VERIFY_CREDENTIALS,
    label: 'account_module.onboard_page.checklist.step_1',
  },
  {
    key: MEGAPHONE_ONBOARDING_STEP_KEYS.CUSTOMIZE_IMPORT,
    label: 'account_module.onboard_page.checklist.step_2',
  },
  {
    key: MEGAPHONE_ONBOARDING_STEP_KEYS.HANDLE_DUPLICATE,
    label: 'account_module.onboard_page.checklist.step_3',
  },
];

export const OnboardChecklist = (): JSX.Element => {
  const { t } = useTranslation();
  const { currentStep, persistedProgressStep } = useMegaphoneOnboardContext();

  return (
    <ChecklistWrapper>
      <div>
        <ChecklistTitle>
          <CopyIcon2 tw='stroke-text-primary' />
          {t('account_module.onboard_page.checklist.title')}
        </ChecklistTitle>
        <ul>
          {megaphoneIntegrationOnboardingChecklist.map(
            (listItem: IntegrationOnboardingChecklistType, index: number) => {
              const isCompleted = index < persistedProgressStep;

              return (
                <ListItem
                  key={listItem.key}
                  css={[listItem.key === currentStep && tw`bg-selected`]}>
                  <ItemCheckbox>
                    {isCompleted && (
                      <CheckmarkWrapper>
                        <CheckMarkIcon tw='stroke-white' />
                      </CheckmarkWrapper>
                    )}
                  </ItemCheckbox>
                  {t(listItem.label)}
                </ListItem>
              );
            }
          )}
        </ul>
      </div>
      <SupportCTA
        onClick={() => {
          if (window.Beacon) {
            window.Beacon('toggle');
          }
        }}>
        {t('account_module.onboard_page.checklist.support_link')}
      </SupportCTA>
    </ChecklistWrapper>
  );
};
